module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_6005.9c335a6c.png";